const FHIRPath = () => {
    return(
      <div className="head">
        <h2>FHIRPath</h2>
      </div>  
    );
}

export default FHIRPath;